import { IMAGE_VIEWERS } from "../../constants/constants";
import { FETCH_INTEGRATOR_START, FETCH_INTEGRATOR_SUCCESS, GENERATE_SESSIONID_ERROR, GENERATE_SESSIONID_SUCCESS, LOAD_ORDER_ERROR, LOAD_ORDER_SUCCESS, SET_MICROPHONE_DEVICE_ID, UNLOAD_ORDER_ERROR, UNLOAD_ORDER_SUCCESS, SET_PAIRED_DICTATION_DEVICE, SET_DEADMAN_SWITCH, FETCH_PACS_SUCCESS, FETCH_PACS_ERROR, SET_MIPS_PACS } from "../actions/integratorActions";
import { SET_DEFAULT_CONFIGURATIONS } from "../actions";

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    status: null,
    sessionCreated: false,
    pacsSessions: [],
    orderLoaded: null,
    imageViewer: IMAGE_VIEWERS.ORTHANC,
    deviceId: null,
    pairedDictationDevice: null,
    useDeadmanSwitch: true,
    pacsList: [],
    mipPacs: {}
};

const integratorReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_DEFAULT_CONFIGURATIONS:{
            return { ...state, useDeadmanSwitch: action.configurations.deadman_switch  }
        }
        case FETCH_INTEGRATOR_START: {
            return { ...state, error: '', message: '', loading: true }
        }
        case FETCH_INTEGRATOR_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, status: action.status }
        }
        case FETCH_PACS_SUCCESS : {
            return { ...state, error: '', message: '', loading: false, pacsList: action.pacs }
        }
        case FETCH_PACS_ERROR : {
            return { ...state, error: '', message: '', loading: false, pacsList: [] }
        }
        case SET_MIPS_PACS : {
            return { ...state, error: '', message: '', loading: false, mipPacs: action.mipPacs }
        }
        case GENERATE_SESSIONID_SUCCESS: {
            const sessionCreated = true;
            const imageViewer = sessionCreated ? IMAGE_VIEWERS.INTELEVIEWER : IMAGE_VIEWERS.ORTHANC;
            let newPacsSessions = [...state.pacsSessions];
            const index = newPacsSessions.findIndex(pacsSession => pacsSession.pacsId === action.pacsSession.pacsId);
            if(index > -1){
                newPacsSessions.splice(index, 1, action.pacsSession);
            } else {
                newPacsSessions.push(action.pacsSession);
            }
            return { ...state, error: '', message: '', loading: false, imageViewer, pacsSessions: newPacsSessions, sessionCreated }
        }
        // case GENERATE_SESSIONID_ERROR: {
        //     return { ...state, error: '', message: '', loading: false, sessionCreated: false, pacsSessions: [] }
        // }
        case LOAD_ORDER_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, orderLoaded: action.order }
        }
        case LOAD_ORDER_ERROR: {
            return { ...state, error: '', message: '', loading: false, orderLoaded: null }
        }
        case UNLOAD_ORDER_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, orderLoaded: null }
        }
        case UNLOAD_ORDER_ERROR: {
            return { ...state, error: '', message: '', loading: false }
        }
        case SET_MICROPHONE_DEVICE_ID: {
            localStorage.setItem("microphoneDeviceId", action.deviceId);
            return { ...state, deviceId: action.deviceId }
        }
        case SET_PAIRED_DICTATION_DEVICE: {
            return { ...state, pairedDictationDevice: action.device }
        }
        case SET_DEADMAN_SWITCH:{
            return { ...state, useDeadmanSwitch: action.useDeadmanSwitch }
        }
        default:
            return state;
    }
}

export default integratorReducer;